import {Action, Module, Mutation} from 'vuex-module-decorators'
import store, {alertModule} from "@/store";
import {MdbsCore} from "@/api/tsclient";
import BaseModule from "@/store/modules/BaseModule";
import PatientDto = MdbsCore.PatientDto;
import PatientCreateDto = MdbsCore.PatientCreateDto;
import IPatientCreateDto = MdbsCore.IPatientCreateDto;
import IPatientUpdateDto = MdbsCore.IPatientUpdateDto;
import PatientUpdateDto = MdbsCore.PatientUpdateDto;

const patientClient = new MdbsCore.PatientClient();

@Module({namespaced: true, name: 'patient', store: store})
export default class PatientModule extends BaseModule {
    patients: Array<PatientDto> = [];

    @Mutation
    setPatients(patients: Array<PatientDto>) {
        this.patients.updateValues(patients);
    }

    @Mutation
    resetPatients() {
        this.patients.clear();
    }

    @Action({rawError: true})
    async loadAll() {
        this.startLoading();
        try {
            this.context.commit('setPatients', await patientClient.getAll(false))
        } catch (e) {
            console.error("patients: loadAll", JSON.stringify(e));
            this.resetPatients();
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async createPatient(patient: IPatientCreateDto) {
        this.startLoading();
        try {
            await patientClient.create(new PatientCreateDto(patient));
            await this.loadAll()
        } catch (e) {
            console.error("patient: create", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }

    @Action({rawError: true})
    async getPatientById(patientId: string) {
        this.startLoading();
        try {
            return await patientClient.findPatient(patientId)
        } catch (e) {
            console.error("patient: get by id", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
        return null;
    }

    @Action({rawError: true})
    async updatePatient(patient: IPatientUpdateDto) {
        this.startLoading();
        try {
            await patientClient.update(patient.id, new PatientUpdateDto(patient));
            await this.loadAll()
        } catch (e) {
            console.error("patient: update", e);
            await alertModule.handleException(e);
        } finally {
            this.stopLoading();
        }
    }
}
